export default __webpack_public_path__ + "static/media/arrow-split-gray.c4ee8549.svg";